import * as React from 'react';
// import { useEffect } from 'react';

import { GoogleMap, LoadScript, Polygon } from '@react-google-maps/api';
// const { MarkerClusterer } = require('react-google-maps/lib/components/addons/MarkerClusterer');
// import { createPortal } from 'react-dom';
import { googleMapsApiKey } from '../config';
// const { MarkerClusterer } = require('react-google-maps/lib/components/addons/MarkerClusterer');
// const MAP = require('react-google-maps/lib/constants').MAP;


export const DEFAULT_BOUNDS = {
    north: 90, south: -90, east: 180, west: -180
};

export interface MapContainerProps {
    markers: any[];
    polygon: any;
    center: google.maps.LatLng | google.maps.LatLngLiteral;
    bounds?: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral;
}


/*function MapControl({position = google.maps.ControlPosition.TOP_LEFT, children}: any, context: React.Context<{MAP: any}>) {
    // const map = context[MAP];
    const controlDiv = document.createElement('div');

    // @ts-ignore
    useEffect(() => {
        console.info('MapControl, map:', map);
        if (map) {
            const controls = map.controls[position];
            const index = controls.length;
            controls.push(controlDiv);
            return () => {
                controls.removeAt(index);
            };
        }
    }, [map]);

    console.info('--------------------MapControl:', context, map);
    return createPortal(
        <div style={{ marginLeft: 16, marginTop: 16 }}>{children}</div>,
        controlDiv
    );
}*/

// MapControl.contextTypes = {
//     [MAP]: PropTypes.object,
// };

/** @deprecated by SearchMap */
const MapContainer = (props: MapContainerProps) => {
    // const _map = React.createRef();

    // useEffect(() => {
    // });

    function onMapMounted(map: any) {
        console.info('map mounted:', map);
        // _map.current = map;
        if (map) {
            // if (props.bounds) {
            //     map.fitBounds(props.bounds as google.maps.LatLngBoundsLiteral);
            // }

            // const closeButton = document.createElement('button');
            // // const img = document.createElement('img');
            // // img.src =
            // closeButton.innerText = 'X';
            // closeButton.title = 'Close the map';
            // closeButton.className = 'gm-control-active';
            // // ReactDOM.createPortal(<Button></Button>, closeButton);
            // // noinspection JSDeprecatedSymbols
            // map.context[MAP].controls[google.maps.ControlPosition.TOP_RIGHT].push(closeButton);
        }
    }

    // gridSize={30}
    return (
        <LoadScript
            googleMapsApiKey={googleMapsApiKey}
            libraries={['geometry', 'drawing', 'places']}
            loadingElement={<div style={{ height: `100%` }} />}
        >
            <GoogleMap
                onLoad={onMapMounted}
                zoom={11}
                center={props.center}
            >
                {/*<MapControl position={google.maps.ControlPosition.TOP_RIGHT}>*/}
                {/*    <button className="gm-control-active" title="Close the map">*/}
                {/*        X*/}
                {/*    </button>*/}
                {/*</MapControl>*/}
                <Polygon {...props.polygon}/>
{/*                <MarkerClusterer
                    averageCenter
                    enableRetinaIcons
                >
                    {props.markers.map(marker => <Marker key={marker.key} {...marker}/>)}
                </MarkerClusterer>*/}
            </GoogleMap>
        </LoadScript>
    );
};
export default MapContainer;

/*

import { Map, Marker, GoogleApiWrapper, GoogleAPI } from 'google-maps-react';
import { googleMapsApiKey } from '../config';
import { useContext } from 'react';



export interface MapContextProps {
    markers: any[];
    bounds?: google.maps.LatLngBounds | google.maps.LatLngBoundsLiteral;
}
export const MapContext = React.createContext<MapContextProps>({
    markers: [],
    bounds: DEFAULT_BOUNDS
});

/!*if (navigator && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(pos => {
        // TODO: better default location
        console.info('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!current position:', pos);
        // pos.coords.latitude
    }, err => {
        // doesn't work on Desktop (proxy?)
        console.info('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!failed to get pos:', err);
    }, {enableHighAccuracy: true, maximumAge: Infinity, timeout: 5000});
}*!/


export type MapRef = {
    current: {
        refs: { map: HTMLDivElement; };
        scriptCache: {
            google: {
                onLoad: () => void;
                tag: {};
            };
        };
        state: {
            google: {
                maps: any;
            };
        };
        _gapi: {
            maps: any;
        }
    } | null;
};

export interface MapProps {
    google: GoogleAPI;
}

function MapContainer(props: MapProps) {
    const context = useContext<MapContextProps>(MapContext);

    /!*function onMarkerClick() {
        console.info('clicked on marker');
    }
    function onInfoWindowClose() {
        console.info('onInfoWindowClose');
    }*!/

/!*<InfoWindow onClose={this.onInfoWindowClose}>
<div>
<h1>this.state.selectedPlace.name}</h1>
</div>
</InfoWindow>*!/

    /!*geocode() {
        console.info('google:', this.props.google);
    }*!/

    function onMapReady(mapProps: any, map: any) {
        console.info('onMapReady:', mapProps, map);
    }

    /!*<Marker
        onClick={onMarkerClick}
        label={'Current location'}
    />*!/
    console.info('-------------------rendering map at ', context.bounds);
    return (
        <Map
            centerAroundCurrentLocation
            google={props.google}
            onReady={onMapReady}
            bounds={context.bounds}
        >
            {context.markers.map(marker => <Marker {...marker}/>)}
        </Map>
    );
}

export default GoogleApiWrapper({
    apiKey: (googleMapsApiKey),
})(MapContainer) as any;
*/
